module.exports = __webpack_public_path__ + "img/login_logo_outflink.03339bcf.png";